import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isAdmin = url.startsWith("/admin") || url.startsWith("/auth");
  const token = isAdmin
    ? localStorage.getItem("lc_admin_token")
    : localStorage.getItem("lc_customer_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatCOP(amount) {
  const n = Math.round(Number(amount) || 0);
  return "$" + n.toLocaleString("es-CO") + " COP";
}
